/* Input:

 filtersDataObj: {
        trim: { readUnread: "0", withNote: false, withAccess: false, disconnected: true, discrepancy: false },
        readings: [],
        spotBillEnabled: false,
        filteredReadings: [],
        showDialog: false,
        saveFilters: this.saveFilters, //function
      },

*/
export default {
  name: "FiltersComp",
  components: {
    ReadUnreadIcon: require('./Icons/readUnread.vue').default,
    NoteIcon: require('./Icons/note.vue').default,
    DiscrepancyIcon: require('./Icons/discrepancy.vue').default,
    DisconnectedIcon: require('./Icons/disconnected.vue').default,
    AccessRestrictionIcon: require('./Icons/accessRestriction.vue').default,
  },
  props: {
    dataObj: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
  },
  data: function () {
    return {
      trim: {
        readUnread: "0",
        withNote: false,
        withAccess: false,
        disconnected: true,
        discrepancy: false
      },
    };
  },
  computed: {
    readingsLength: function () {
      return this.dataObj && this.dataObj.readings ? this.dataObj.readings.length : 0;
    },
    disabledByStatus: function () {
      return this.dataObj.trim.readUnread == "1";
    }
  },
  watch: {
    readingsLength: function (val) {
      this.trimReadings();
    },
    "dataObj.showDialog": function (val) {
      if (val)
        this.trim = { ...this.dataObj.trim };
    }
  },
  mounted() {
    this.getFilterFromLocal();
  },
  methods: {
    readUnreadChanged(val) {
      if (val != 0) {
        this.dataObj.trim.withAccess = false;
        this.dataObj.trim.withNote = false;
        this.dataObj.trim.discrepancy = false;
      }
    },
    showFiltersDialog(action = true) {
      if (this.disabled == true && action == true)
        return;

      if (!action && this.dataObj && this.dataObj.saveFilters)
        this.dataObj.saveFilters(this.dataObj.trim);

      this.dataObj.showDialog = action;
    },
    isRaised(item, isIcon = false) {
      if (item == "0")
        return;

      if (isIcon)
        return item ? 'color-white' : '';
      else
        return item ? ' md-raised background-light-gray' : '';
    },
    trimReadings() {
      let results = [...this.dataObj.readings], msg = '';
      this.dataObj.filteredReadings = [...this.dataObj.readings];

      //trim readings depending on trim buttons 
      if (this.dataObj.trim.readUnread == 1) { // unread
        //save everything to results
        results = results.filter(r => r.readingDiscrepancyType == 2);
        if (results.length == 0) { //if results not exist reset selection add msg
          this.dataObj.trim.readUnread = "0";
          msg = msg + this.$t('captureMR.filterMsgUnreadError') + '<br />';
          results = this.dataObj.filteredReadings; //reset filtering to previous filter results
        }
        else //if results add them to filteredreadings
          this.dataObj.filteredReadings = results;
      }
      else if (this.dataObj.trim.readUnread == 2) { // read
        results = results.filter(r => r.readingDiscrepancyType != 2);
        if (results.length == 0) {
          this.dataObj.trim.readUnread = "0";
          msg = msg + this.$t('captureMR.filterMsgReadError') + '<br />';
          results = this.dataObj.filteredReadings;
        }
        else //if results add them to filteredreadings
          this.dataObj.filteredReadings = results;
      }
      else if (this.dataObj.trim.readUnread == 3 && this.dataObj.spotBillEnabled === true) { // read
        //results = results.filter(r => (r.statementNo == null || r.statementNo == '') && r.crReading != null && r.crReading != '');
        results = results.filter(r => r.statementNo);
        if (results.length == 0) {
          this.dataObj.trim.readUnread = "0";
          msg = msg + this.$t('captureMR.filterMsgSpotBillError') + '<br />';
          results = this.dataObj.filteredReadings;
        }
        else //if results add them to filteredreadings
          this.dataObj.filteredReadings = results;
      }
      else if (this.dataObj.trim.readUnread == 3 && this.dataObj.spotBillEnabled != true) {
        this.dataObj.trim.readUnread = "0";
        this.trimReadings();
        return;
      }

      if (this.dataObj.trim.withNote == true) {
        results = results.filter(r => r.mrMsgCodeId != 0);
        if (results.length == 0) {
          this.dataObj.trim.withNote = false;
          msg = msg + this.$t('captureMR.filterMsgNoteError') + '<br />';
          results = this.dataObj.filteredReadings;
        }
        else
          this.dataObj.filteredReadings = results;
      }

      if (this.dataObj.trim.withAccess == true) {
        results = results.filter(r => r.readingDiscrepancyType == 1 && r.accessCodeId != 0);
        if (results.length == 0) {
          this.dataObj.trim.withAccess = false;
          msg = msg + this.$t('captureMR.filterMsgAccessError') + '<br />';
          results = this.dataObj.filteredReadings;
        }
        else
          this.dataObj.filteredReadings = results;
      }

      if (this.dataObj.trim.discrepancy == true) {
        results = results.filter(r => r.readingDiscrepancyType >= 3 && r.readingDiscrepancyType <= 17 && r.status != 3);
        if (results.length == 0) {
          this.dataObj.trim.discrepancy = false;
          msg = msg + this.$t('captureMR.filterDiscrepancyError') + '<br />';
          results = this.dataObj.filteredReadings;
        }
        else
          this.dataObj.filteredReadings = results;
      }

      //if no filtered readings load everything
      if (this.dataObj.filteredReadings.length == 0) {
        msg = this.$t('captureMR.filterReadingsNoResults');
        this.dataObj.trim.readUnread = "0";
        this.dataObj.trim.withNote = false;
        this.dataObj.trim.withAccess = false;
        this.dataObj.trim.disconnected = false;
        this.dataObj.trim.discrepancy = false;
        this.dataObj.filteredReadings = [...this.dataObj.readings];
      }

      //disconnected show-hide
      if (this.dataObj.trim.disconnected == false) { //remove disconnected
        let discIndex = this.dataObj.filteredReadings.map(e => e.connectionStatus == 2 || e.connectionStatus == 3);

        for (let i = discIndex.length - 1; i >= 0; i--) {
          if (discIndex[i] === true) {
            this.dataObj.filteredReadings.splice(i, 1);
          }
        }
      }

      this.dataObj.filteredReadings.sort((a, b) => a.sequence < b.sequence);

      //messages
      if (this.dataObj.trim.readUnread == 0 && this.dataObj.trim.withNote == false &&
        this.dataObj.trim.withAccess == false && this.dataObj.trim.withNote == false && this.dataObj.trim.discrepancy == false) {
        msg = msg + this.$t('captureMR.filterReadingsAll');
      }
      else {
        if (this.dataObj.trim.readUnread == 1)
          msg = msg + this.$t('captureMR.filterMsgUnread') + '<br />';
        else if (this.dataObj.trim.readUnread == 2)
          msg = msg + this.$t('captureMR.filterMsgRead') + '<br />';
        else if (this.dataObj.trim.readUnread == 3)
          msg = msg + this.$t('captureMR.filterMsgSpotBill') + '<br />';

        if (this.dataObj.trim.withNote == true)
          msg = msg + this.$t('captureMR.filterMsgNote') + '<br />';

        if (this.dataObj.trim.withAccess == true)
          msg = msg + this.$t('captureMR.filterMsgAccess') + '<br />';

        if (this.dataObj.trim.discrepancy == true)
          msg = msg + this.$t('captureMR.filterDiscrepancy') + '<br />';
      }

      if (this.dataObj.trim.disconnected == true)
        msg = msg == '' ? this.$t('captureMR.filterMsgDisconnectedOn') : msg + '<br />' + this.$t('captureMR.filterMsgDisconnectedOn');
      else
        msg = msg == '' ? this.$t('captureMR.filterMsgDisconnectedOff') : msg + '<br />' + this.$t('captureMR.filterMsgDisconnectedOff');

      this.$oldAlertMsg(msg, 1, true);
      this.saveFilterLocally();
    },

    getFilterFromLocal() {
      let temp = this.$localStorage.get('_captureMeterReadingFilters');
      if (temp) {
        this.dataObj.trim = JSON.parse(temp);

        if (this.dataObj && this.dataObj.saveFilters)
          this.dataObj.saveFilters(this.dataObj.trim);
      }

      this.trimReadings();
    },
    saveFilterLocally() {
      this.$localStorage.set('_captureMeterReadingFilters', JSON.stringify(this.dataObj.trim));
    },

    close(reset = false) {
      if (reset) {
        this.dataObj.trim = { ...this.trim };
      }
      else 
        this.trimReadings();

      this.showFiltersDialog(false);
    },
  }
};
